import React from "react";
import "./GrantAccessRequest.less";
import {
  Button
} from "@material-ui/core";
import commonLabels from "../../../constants/messageConstants";
import { apiPost } from "../../../utils/api_service";
import { API_URL } from "../../../constants/api";
import { ShowToast, toastType } from "../../../utils/toast-service";
import GuidelineFile from "./GuidelineFile";
import ThankYouAndPatience from "./ThankYouAndPatience";
import SignaturePopup from "./SignaturePopup";

export default class BiometricRequest extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openDialog: true,
      openBiometricDialog: false,
      openSignBiometricDialog: false,
      successDialog: false
    };
  }

  static getDerivedStateFromProps() {}

  /**
   * open signature dialog
   */
  openSignatureDialog = () => {
    this.setState({ openSignBiometricDialog: true, openBiometricDialog: false });
  };

  /**
   * open and hide loader
   * @param {*} e 
   */
  handleLoader = e => {
    const { handleLoader } = this.props;
    handleLoader(e);
  };

  /** data conversion to blob format */
  dataURItoBlob(dataURI) {
    const byteString = atob(dataURI.split(",")[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    const bb = new Blob([ab]);
    return bb;
  }

  /** Upload file to database */
  uploadFileToDb = sign => {
    const { visitorData, biometrics } = this.props;
    const requestBody = new FormData();
    requestBody.append("RequestId", visitorData?.RequestId || "");
   
    requestBody.append(
      "BiometricsSignatureImage",
      this.dataURItoBlob(sign.src ? sign.src : sign),
      "sign.png"
    );

    requestBody.append(
        "BiometricDetailsString",
        JSON.stringify(biometrics)
      );

    this.handleLoader(true);
    this.onSubmit(requestBody);
  };

  /** call on submit button */
  onSubmit = data => {
    apiPost({
      url: API_URL.request.SaveRequestBiometricsForm,
      postBody: data
    }).then(({ success: isExecuted }) => {
      const { visitorData, biometrics, setRequestDetails } = this.props;
      if (isExecuted == true) {
        visitorData.IsSignedDocument = true;
        ShowToast("Record updated successfully", toastType.SUCCESS, 5000, 200);
        this.setState({
          openSignBiometricDialog: false,
          openBiometricDialog: false,
          successDialog: biometrics?.filter(x => x.requireBiometrics === true) !== undefined
        });
      } else {
        ShowToast(
          commonLabels.somethingWrong.message,
          toastType.ERROR,
          5000,
          commonLabels.somethingWrong.code
        );
      }
      
      this.handleLoader(false);
      setRequestDetails(visitorData, biometrics); 
    });
  };

  /**
   * call on handle BRR
   * @param {*} e 
   */
  handleBrr(e) {
    if (e) {
      this.setState({ openDialog: false, openSignBiometricDialog: true });
    } else this.setState({ openDialog: false, openBiometricDialog: true });
  }

  /**
   * call on close popup
   */

  clickOnClose =() => {
    this.setState({
        openBiometricDialog: false,
        openDialog: true
      });
  }

  /**
   * close signature popup
   */
  closeSignaturePopup = () => {
    this.setState({
      openSignBiometricDialog: false,
      openDialog: true
      });
  }

  render() {
    const {
      openDialog,
      openSignBiometricDialog,
      openBiometricDialog,
      successDialog
    } = this.state;
    const { visitorData, biometrics } = this.props;
    const biometricData =  biometrics?.find(x => x.requireBiometrics === true);
    return (
      <>
        <div className={"col-xs-12 abrf-request-container"}>
          {openDialog && (
            <div>
              <div className={"col-xs-12"}>
                <span className={"span-brr-label"}>
                  {commonLabels.enableBiometricSectionMessage.message}
                </span>
              </div>
              <div className={"row"}>
                <div className={"col-xs-12 end-xs req-btn"}>
                  <Button
                    autoFocus
                    onClick={() => this.handleBrr(true)}
                    variant={"contained"}
                  >
                    {"Yes\r"}
                  </Button>
                  <Button
                    autoFocus
                    onClick={() => this.handleBrr(false)}
                    variant={"contained"}
                  >
                    {"No\r"}
                  </Button>
                </div>
              </div>
            </div>
          )}
          {openSignBiometricDialog && (
            <SignaturePopup
              closeSignaturePopup={this.closeSignaturePopup}
              openSignDialog={openSignBiometricDialog}
              uploadFileToDb={this.uploadFileToDb}
              visitorData={visitorData}
            />
          )}
          {openBiometricDialog && (
            <GuidelineFile 
              openGuideline={openBiometricDialog}
              guidelineHeader={"Please read Biometric Agreement before you submit.\r"}
              openSignatureDialog={this.openSignatureDialog}
              clickOnClose={this.clickOnClose}
              pdfUrl={"public/releases/biometric/"+biometricData.biometricsAgreementName.replace("@@Data Center@@", biometricData.abbreviation)+".pdf#zoom=100"} 
              pdfHeader={"Biometric Agreement "}    
              height={"2250px"}
			        agreeText={"I have read and understand the provided information and agree to sign the 'Acknowledgement Form\'."}
              className={"biometric-agreement"}              
            />
          )}
        </div>

        {successDialog && (
          <ThankYouAndPatience
            successDialog={successDialog}
          />
        )}
      </>
    );
  }
}
